import { render, staticRenderFns } from "./ProtospellingNew.vue?vue&type=template&id=d05b337c&"
import script from "./ProtospellingNew.vue?vue&type=script&lang=js&"
export * from "./ProtospellingNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports